import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

interface LocationState {
  from?: { pathname?: string; search?: string };
}

export default function Login() {
  const { session, member, signInWithGoogle, loading } = useAuth();
  const location = useLocation();

  // If already authenticated with a team roster match, redirect back to wherever
  // the user was originally headed (set by ProtectedRoute via state.from).
  // This preserves query strings — important for the QBO OAuth success flow,
  // where the callback redirects to /admin?qb_oauth=success&realm=...&state=...
  // and the success toast needs to render.
  if (!loading && session && member) {
    const from = (location.state as LocationState | null)?.from;
    const redirectTo = from?.pathname
      ? `${from.pathname}${from.search ?? ""}`
      : "/";
    return <Navigate to={redirectTo} replace />;
  }

  // Show a spinner while auth is resolving (prevents flash of login page)
  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-slate-500">
        Loading…
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-bardin-sky p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow p-8 text-center">
        <div className="flex justify-center mb-4">
          <img src="/img/bardin-logo.png" alt="Bardin Roofing" className="h-16" />
        </div>
        <h1 className="text-2xl font-semibold text-bardin-ink">Bardin Roofing</h1>
        <p className="text-slate-500 mb-6 mt-1">Staff Portal</p>
        <button
          onClick={signInWithGoogle}
          className="w-full px-4 py-2.5 rounded-lg bg-bardin-ink text-white hover:bg-slate-800"
        >
          Sign in with Google
        </button>
        <p className="mt-4 text-xs text-slate-400">
          Use your @bardinroofing.com account.
        </p>
      </div>
    </div>
  );
}
